import React from "react";
import { useUserSites } from "../hooks";
import { RemoveUserSite } from "./remove-user-site";

interface IUserSitesList {
  userId: number;
}

export const UserSitesList: React.FC<IUserSitesList> = ({ userId }) => {
  const { data, loading, refetch, error } = useUserSites({ where: { userId } });
  return (
    <div>
      {loading ? <div>Loading...</div> : null}
      {data?.userSites?.results?.map((us) => (
        <div key={us.id} className="flex align-items">
          <span className="flex-1">{us.site?.name}</span>
          <RemoveUserSite userSiteId={us.id} refetch={refetch} />
        </div>
      ))}
    </div>
  );
};
